module.exports = __webpack_public_path__ + "img/sp_foot_ico01.504f664f.svg";